import React from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//redux
import { connect } from 'react-redux';

// dates
import moment from 'moment';

// components
import { ProductController } from "controllers";
import { AppContext, WarningModal } from "components";
import { BaseComponent, SelectWeek } from "shared/components";

// reducers
import { clearActiveCustomer } from "hyc-store/reducers/customers";

// components
import { ProductRow } from "shared/components/product-row/product-row";
import { Hero } from "shared/components/bulma/hero";
import { Button } from "shared/components/bulma/button";
import { Checkbox } from "shared/components/bulma/checkbox";
import { DatePicker } from "shared/components/bulma/date-picker";
import { CustomSearchBarWithSelect } from "shared/components/customers/customer-search-bar-with-select";
import { ActionBar } from "shared/components/action-bar";

// helpers
import { productAddNewFunction } from "./product-add-new-function";

class ProductAddContainer extends BaseComponent {
    constructor(props) {
        super(props);

        this.defaultWeek = 'Week 1';
        if (props.shipmentWeek) {
            this.defaultWeek = props.shipmentWeek;
        }

        this.state = {
            barcode: "",
            userSelected: null,
            barcodes: [],
            loading: false,
            isModalVisible: false,
            selectedDate: moment().add(5, 'week').calendar(),
            shipmentWeek: this.defaultWeek,
            extraBox: false,
            replacementBox: false,
            winbackBox: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
        this.selectCustomer = this.selectCustomer.bind(this);
    }

    componentDidMount = async () => {
        toast.configure({
            autoClose: 2000,
            draggable: false
            //etc you get the idea
        });

        document.getElementById('barcode').addEventListener("keypress", function (e) {
            if (e.target.tagName !== "INPUT") {
                var input = document.querySelector("#barcode");
                input.focus();
                input.value = e.key;
                e.preventDefault();
            }
        });
    };

    handleChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    onChangeCheckbox(event) {
        const { name } = event.currentTarget;
        const checkboxValue = this.state[name];
        this.setState({ [name]: !checkboxValue });
    }

    selectCustomer(customer) {
        const s = { userSelected: customer };

        if (!customer) {
            s.barcodes = [];
        }

        this.setState(s);
    }

    removeBarCode = code => {
        let { barcodes } = this.state;
        barcodes = barcodes.filter(product => {
            return product.barcode !== code.barcode;
        });
        this.setState({ barcodes });
    };

    searchInputKeyPressed = async (event) => {
        const { country } = this.props;
        let { barcodes, barcode, userSelected } = this.state;

        if (event.charCode === 13) {
            let product = null;

            this.setState({ loading: true });
            this.context.showLoading();

            try {
                product = await productAddNewFunction({ barcodes, barcode, customer: userSelected, country });
            } catch (error) {
                toast.error(error.message, {
                    position: toast.POSITION.TOP_LEFT
                });
            }

            this.context.hideLoading();
            this.setState({ loading: false });

            if (!product) {
                this.setState({ barcode: '' });
                return;
            }

            barcodes.push(product);
            this.setState({ barcodes, barcode: '' });
        } else {
            this.setState({ barcode: event.target.value });
        }
    };

    addClicked = async () => {
        let { userSelected, barcodes } = this.state;
        if (!userSelected) {
            toast.error("Please select customer!", {
                position: toast.POSITION.TOP_LEFT
            });
            return;
        }
        if (barcodes.length === 0) {
            toast.error("Please select barcodes!", {
                position: toast.POSITION.TOP_LEFT
            });
            return;
        }

        this.setState({
            isModalVisible: true
        });
    };

    handleModalDisagree = () => {
        this.setState({
            isModalVisible: false
        });
    }

    handleModalAgree = async () => {
        this.setState({
            loading: true,
            isModalVisible: false
        });

        const {
            barcodes,
            userSelected,
            selectedDate,
            shipmentWeek,
            extraBox,
            replacementBox,
            winbackBox
        } = this.state;
        const unixSelectedDate = new Date(selectedDate).getTime();
        const boxType = [];
        if (extraBox) { boxType.push('extra_box') }
        if (replacementBox) { boxType.push('replacement_box') }
        if (winbackBox) { boxType.push('win_back_box') }
        this.context.showLoading();
        try {
            await ProductController.addProducts({ user: userSelected, barcodes, return_date: unixSelectedDate, shipment_week: shipmentWeek, status: 'at_customer', box_type: boxType });
            await this.setState({
                barcode: "",
                userSelected: null,
                barcodes: [],
                extraBox: false,
                replacementBox: false,
                winbackBox: false
            });

            toast.success("Success!", {
                position: toast.POSITION.TOP_LEFT
            });

            this.context.hideLoading();
            this.props.clearActiveCustomer();
        } catch (error) {
            toast.error(error.message, {
                position: toast.POSITION.TOP_LEFT
            });
        }
        this.context.hideLoading();
        this.setState({ loading: false });
    };

    render() {
        const { barcodes, barcode, selectedDate, shipmentWeek, replacementBox, extraBox, winbackBox } = this.state;

        return (

            <>
                <Hero className="is-light is-small">

                    <CustomSearchBarWithSelect name="customer"
                        country={this.props.country}
                        onChange={this.selectCustomer} />

                </Hero>

                <div className="columns is-gapless">
                    <div className="column is-3 m-6">
                        <SelectWeek
                            id="week-select"
                            label="Shipment Week"
                            name="shipmentWeek"
                            value={shipmentWeek}
                            onChange={this.handleChange} />

                        <DatePicker
                            label={'Date of Return'}
                            id={'date-return'}
                            name="selectedDate"
                            value={selectedDate}
                            onChange={this.handleChange} />

                        <div className="field">
                            <label className="label">Box Type</label>

                            <Checkbox name="extraBox"
                                onChange={this.onChangeCheckbox}
                                checked={extraBox}>
                                Extra Box
                            </Checkbox>

                            <Checkbox name="replacementBox"
                                onChange={this.onChangeCheckbox}
                                checked={replacementBox}>
                                Replacement Box
                            </Checkbox>

                            <Checkbox name="winbackBox"
                                onChange={this.onChangeCheckbox}
                                checked={winbackBox}>
                                Win Back
                            </Checkbox>

                        </div>
                    </div>

                    <div className="column m-6">
                        <div className="container">

                            <label className="label is-size-6">Barcode</label>
                            <input className="input"
                                onChange={this.handleChange}
                                name="barcode"
                                placeholder="Barcode"
                                onKeyPress={this.searchInputKeyPressed}
                                value={barcode}
                                id="barcode"
                            />

                            <div className="columns is-multiline mt-4">
                                {barcodes.map((product) => (
                                    <div key={product.barcode} className="column is-6">
                                        <ProductRow product={product}
                                            washing={false}
                                            onRemove={this.removeBarCode} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {!!barcodes.length && (
                    <ActionBar>
                        <Button className="is-primary" onClick={this.addClicked} >
                            Create box customer with {barcodes.length} products
                        </Button>
                    </ActionBar>
                )}

                {/** Show WarningModal */}
                <WarningModal
                    open={this.state.isModalVisible}
                    contentText={`Are you sure to send these items to the customer?`}
                    onDisagree={this.handleModalDisagree}
                    onAgree={this.handleModalAgree}
                />
            </>
        );
    }
}

ProductAddContainer.contextType = AppContext;

ProductAddContainer.propTypes = {
    history: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
    return { ...ownProps, country: state.countries.value }
}

const mapDispatchToProps = (dispatch) => {
    return {
        clearActiveCustomer: () => dispatch(clearActiveCustomer())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAddContainer);
